import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { TableRow, Radio, TableData } from '@ctct/ui-react';

import CurrentPlanBadge from './CurrentPlanBadge';
import { formatCurrency } from '../../../utils/pricingUtils';

const defaultProps = {
  visibleTableRow: false,
  prepayDiscountPercentage: 1,
  priceAllZeroDecimal: false,
};

const propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  prepayDiscountPercentage: PropTypes.number,
  selectedSMSTierMin: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  selectTierCallback: PropTypes.func.isRequired,
  scrolledIntoView: PropTypes.bool.isRequired,
  initiallySelectedTier: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  setScrolledIntoView: PropTypes.func.isRequired,
  visibleTableRow: PropTypes.bool,
  priceAllZeroDecimal: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

const SMSTiersTableRow = ({
  min,
  max,
  price,
  prepayDiscountPercentage,
  selectedSMSTierMin,
  selectTierCallback,
  currency,
  scrolledIntoView,
  initiallySelectedTier,
  setScrolledIntoView,
  isDisabled,
  visibleTableRow,
  priceAllZeroDecimal,
  t,
}) => {
  useEffect(() => {
    // scroll row into view if it's the selected row (recommended is selected by default)
    if (min === selectedSMSTierMin && !scrolledIntoView) {
      const rowMin = document.getElementById(`row-${min}vtr`);

      if (rowMin) {
        rowMin.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        setScrolledIntoView(true);
      }
    }
  }, []);

  return (
    <TableRow id={`row-${min}${visibleTableRow ? 'vtr' : ''}`}>
      <TableData contentType="icon">
        <Radio
          name="sms-tiers"
          disabled={isDisabled}
          id={`sms-tiers-${min}`}
          value={`${min}`}
          checked={min === selectedSMSTierMin}
          onChange={() => {
            selectTierCallback(min, max, price);
          }}
        />
      </TableData>
      <TableData>
        {`${min.toLocaleString()} - ${max > 0 ? max.toLocaleString() : t('sms-plans.unlimited')}`}
        {initiallySelectedTier && (
          <span style={{ paddingLeft: 20, marginRight: -110 }}>
            <CurrentPlanBadge data-qe-id="sms-current-plan-badge" t={t} />
          </span>
        )}
      </TableData>
      <TableData>
        <div>
          {prepayDiscountPercentage !== 1 && (
            <div
              style={{
                textAlign: 'right',
                color: 'gray',
                textDecorationLine: 'line-through',
                display: 'inline-block',
                paddingRight: 15,
              }}
            >
              {formatCurrency(currency, price, 0)}
            </div>
          )}
          {formatCurrency(currency, prepayDiscountPercentage * price, priceAllZeroDecimal ? 0 : 2)}
        </div>
      </TableData>
    </TableRow>
  );
};

SMSTiersTableRow.propTypes = propTypes;
SMSTiersTableRow.defaultProps = defaultProps;

export default SMSTiersTableRow;
